export default __webpack_public_path__ + "static/3-efa7099fdfe471509dc593f440607223.jpeg";